// import { Outlet } from "react-router-dom";

import { LayoutContainer } from "../../styles/modal_layout";


type LayoutProps = {
  title?: string,
  onClickLeftButton?: () => void,
  onClickRightButton?: () => void,
  leftButtonText?: string
  rightButtonText?: string,
  isDisableRightButton?: boolean,
  children: React.ReactNode
}


export default function BaseModal(props: LayoutProps) {
  return (
    <LayoutContainer className="modal_layout">
      <div className="card">
        {props.title && (
          <section className="card_top">
            <strong className="fs16">{props.title}</strong>
          </section>
        )}

        {props.children}

        <section className="card_bottom flex">
          {(props.onClickLeftButton) && (
            <button className="contained_gray flex1"
              onClick={props.onClickLeftButton}
            >{props.leftButtonText !== undefined ? props.leftButtonText : '취소'}</button>
          )}
          <button className="contained_main flex1"
            onClick={() => {
              if(props.onClickRightButton) props.onClickRightButton()
            }}
            disabled={props.isDisableRightButton !== undefined && props.isDisableRightButton}
          >{props.rightButtonText ? props.rightButtonText : '확인'}</button>
        </section>
      </div>
    </LayoutContainer>
  )
}